import { ReactElement, ReactNode } from "react";

export default function Emoji({ children, ...props }: { children: ReactNode }): ReactElement | null {
  return (
    <span
      {...props}
      style={{
        // https://www.tjvantoll.com/2016/06/15/emoji-on-windows
        fontFamily: "Segoe UI Emoji",
      }}
    >
      {children}
    </span>
  );
}
